var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { actions } from './actions';
import { mutations } from './mutations';
import { MobileLoadingStates } from '../types';
import { AbstractRepository } from 'packages/core/AbstractRepository';
import ENV from 'config/env';
import { Candidate } from 'packages/v3/jobs/Candidate';
import { EntityBuilder } from '@decahedron/entity';
import { Thread } from 'packages/email/entities/Thread';
import { TalentTimelineItem } from 'packages/talent/entities/TalentTimelineItem';
var PipelineCandidateRepository = /** @class */ (function (_super) {
    __extends(PipelineCandidateRepository, _super);
    function PipelineCandidateRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_ROOT + "v3/";
        _this.entity = Candidate;
        _this.url = 'jobs/:id';
        return _this;
    }
    PipelineCandidateRepository.prototype.getCandidateInJob = function (jobId, talentId) {
        var _this = this;
        return this.get(this.url + "/candidates/:candidateId", {
            id: jobId,
            candidateId: talentId,
        }).then(function (result) { return EntityBuilder.buildOne(Candidate, _this.responseTransformer(result).data); });
    };
    return PipelineCandidateRepository;
}(AbstractRepository));
export { PipelineCandidateRepository };
var ThreadRepository = /** @class */ (function (_super) {
    __extends(ThreadRepository, _super);
    function ThreadRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        _this.entity = Thread;
        _this.url = 'talents/:talentId/threads';
        return _this;
    }
    ThreadRepository.prototype.getThreadsForTalent = function (talentId, jobId) {
        return this.getCursored({ talentId: talentId }, jobId ? { job_id: jobId } : null);
    };
    ThreadRepository.prototype.getTalentThread = function (threadId, talentId, jobId) {
        return this.getOne(this.url, { talentId: talentId }, jobId ? { job_id: jobId } : null);
    };
    return ThreadRepository;
}(AbstractRepository));
export { ThreadRepository };
var TalentTimelineRepository = /** @class */ (function (_super) {
    __extends(TalentTimelineRepository, _super);
    function TalentTimelineRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = ENV.JOBILLA_API_V2_URL;
        _this.url = 'talents/:talentId/events';
        _this.entity = TalentTimelineItem;
        return _this;
    }
    TalentTimelineRepository.prototype.getTimelineForTalent = function (talentId) {
        return this.getCursored({ talentId: talentId });
    };
    return TalentTimelineRepository;
}(AbstractRepository));
export { TalentTimelineRepository };
var state = {
    candidate: null,
    job: null,
    loading: new MobileLoadingStates(),
    forms: null,
    files: null,
    threads: null,
    selectedThread: null,
    timeline: null,
};
export var mobile = {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
